export default __webpack_public_path__ + "static/media/house-2.7af50cfa.jpg";